module.exports = __webpack_public_path__ + "static/media/prev.37d75b16.svg";